export const frMessages = {
    "custom": {
      
        "language": "Langue",
        "accounting" : "aa"

    },
    
};